import React, { useState, useEffect } from "react";
import Dialog from "../../CoreComponent/Dialog";
import httpService from "../../common/httpService";
import toast from "react-hot-toast";
import { DataGrid } from "@mui/x-data-grid";
import { Typography, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const OthersAttendanceComponent = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [selectedAttendee, setSelectedAttendee] = useState(null);
  const [conferenceId, setConferenceId] = useState(62);
  const [conferences, setConferences] = useState([]);

  const token = localStorage.getItem("token");

  // ⭐ UPDATED: Fetch conference list from /conferences/all
  const fetchConferences = async () => {
    try {
      await httpService({
        method: "GET",
        url: "https://eventscons.com/eventbackendnew/api/conferences/all",
        headers: { Authorization: `Bearer ${token}` },
        onSuccess: (data) => {
          setConferences(data?.data || []); // API returns { data: [ ... ] }
        },
        onError: (error) => console.error(error),
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAttendances = async (id) => {
    try {
      await httpService({
        method: "GET",
        url: `https://eventscons.com/eventbackendnew/api/conferences/${id}/others/list`,
        headers: { Authorization: `Bearer ${token}` },
        onSuccess: (data) => {
          setAttendanceData(data?.others || []);
        },
        onError: (error) =>
          setErrorMsg(error?.message || "Failed to fetch attendance records."),
      });
    } catch (error) {
      console.log(error);
      setErrorMsg("Failed to fetch attendance records.");
    }
  };

  // APPROVE ATTENDEE
  const handleConfirm = async (attendance) => {
    try {
      await httpService({
        method: "POST",
        url: `https://eventscons.com/eventbackendnew/api/others/approve/${attendance.id}`,
        headers: { Authorization: `Bearer ${token}` },
        onSuccess: (data) => {
          toast.success(data?.message || `${attendance.full_name} approved successfully`);
          fetchAttendances(conferenceId);
        },
        onError: (error) => {
          toast.error(error?.message || "Failed to approve attendee");
        },
      });
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while approving");
    }
  };

  const handleView = (attendee) => {
    setSelectedAttendee(attendee);
    setDialogOpen(true);
  };

  useEffect(() => {
    fetchConferences();
  }, []);

  useEffect(() => {
    fetchAttendances(conferenceId);
  }, [conferenceId]);

  const rows = attendanceData.map((item) => ({
    id: item.id,
    full_name: item.name,
    email: item.email,
    phone: item.phone_number,
    whatsapp: item.whatsapp_number,
    nationality: item.nationality,
    role: item.role,
    image: item.image ? `https://eventscons.com/eventbackendnew/storage/app/public/${item.image}`
    : "",
  }));

  const columns = [
    { field: "full_name", headerName: "Full Name", flex: 1, minWidth: 200 },
    { field: "email", headerName: "Email Address", flex: 1, minWidth: 220 },
    { field: "phone", headerName: "Phone Number", flex: 1, minWidth: 180 },
    { field: "whatsapp", headerName: "WhatsApp Number", flex: 1, minWidth: 180 },
    { field: "nationality", headerName: "Nationality", flex: 1, minWidth: 150 },
    { field: "role", headerName: "Role", flex: 1, minWidth: 150 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <button
            className="view-button"
            style={{
              padding: "2px 12px",
              background: "#2e7d32",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={() => handleView(params.row)}
          >
            View
          </button>

          <button
            className="confirm-button"
            style={{
              padding: "2px 12px",
              background: "#1976d2",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={() => handleConfirm(params.row)}
          >
            Confirm
          </button>
        </div>
      ),
    },
  ];

  return (
    <div style={{ borderRadius: "8px", width: "100%", maxWidth: "1700px", padding: "20px" }}>
      <Typography
        variant="h6"
        sx={{
          color: "#c62828",
          fontWeight: "bold",
          fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
          textAlign: "center",
        }}
      >
        All Others Attendances
      </Typography>

      {/* ⭐ Fixed Dropdown */}
      <FormControl fullWidth style={{ margin: "20px 0" }}>
        <InputLabel>Select Conference</InputLabel>
        <Select
          value={conferenceId}
          label="Select Conference"
          onChange={(e) => setConferenceId(e.target.value)}
        >
          {conferences.map((conf) => (
            <MenuItem key={conf.id} value={conf.id}>
              {conf.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <DataGrid
        getRowId={(row) => row.id}
        rows={rows}
        columns={columns}
        pageSizeOptions={[12]}
        autoHeight
        sx={{ marginTop: "20px" }}
      />

      {isDialogOpen && selectedAttendee && (
        <Dialog
          viewHeader={true}
          header="Request Details"
          open={isDialogOpen}
          setOpen={setDialogOpen}
          className="dialog-view"
        >
          <div style={{ padding: "20px" }}>
            {selectedAttendee.image && (
              <img
                src={selectedAttendee.image}
                alt={selectedAttendee.full_name}
                style={{ width: "150px", height: "150px", objectFit: "cover", marginBottom: "15px" }}
              />
            )}
          

            <Typography variant="body1">
              <strong>Full Name:</strong> {selectedAttendee.full_name}
            </Typography>
            <Typography variant="body1">
              <strong>Email:</strong> {selectedAttendee.email}
            </Typography>
            <Typography variant="body1">
              <strong>Phone:</strong> {selectedAttendee.phone}
            </Typography>
            <Typography variant="body1">
              <strong>WhatsApp:</strong> {selectedAttendee.whatsapp}
            </Typography>
            <Typography variant="body1">
              <strong>Nationality:</strong> {selectedAttendee.nationality}
            </Typography>
            <Typography variant="body1">
              <strong>Role:</strong> {selectedAttendee.role}
            </Typography>

            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <button
                className="cancel-button"
                onClick={() => setDialogOpen(false)}
                style={{
                  padding: "6px 15px",
                  background: "#c62828",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default OthersAttendanceComponent;
